export const getVariantStyles = (variant, theme) => {
  const tokens = {
    default: {
      backgroundColor: theme.color['fill-surface-recessed'],
      border: `${theme.borderWidth['100']} dashed ${theme.color['fill-accent-neutral-hover']}`,
      color: theme.color['icon-core-default'],
      iconColor: 'icon-core-default'
    },
    hover: {
      backgroundColor: theme.color['fill-info-subtle'],
      border: `${theme.borderWidth['100']} dashed ${theme.color['border-info-default']}`,
      color: theme.color['text-core-default'],
      iconColor: 'icon-interactive-hover'
    },
    processing: {
      backgroundColor: theme.color['fill-surface-raised'],
      border: `${theme.borderWidth['100']} solid ${theme.color['fill-surface-raised']}`,
      color: theme.color['text-core-default'],
      iconColor: 'icon-core-default'
    },
    selected: {
      backgroundColor: theme.color['fill-surface-raised'],
      border: `${theme.borderWidth['100']} solid ${theme.color['fill-surface-raised']}`,
      color: theme.color['text-core-default'],
      iconColor: 'icon-core-default'
    },
    error: {
      backgroundColor: theme.color['fill-alert-subtle'],
      border: `${theme.borderWidth['100']} dashed ${theme.color['border-alert-default']}`,
      color: theme.color['text-core-default'],
      iconColor: 'icon-alert-default'
    },
    success: {
      backgroundColor: theme.color['fill-positive-subtle'],
      border: `${theme.borderWidth['100']} dashed ${theme.color['border-positive-default']}`,
      color: theme.color['text-core-default'],
      iconColor: 'fill-positive-default'
    }
  };
  return tokens[variant];
};
export const iconSizeTokensMap = {
  small: '300',
  medium: '800',
  large: '900',
  xxs: '300',
  xs: '600',
  sm: '900',
  md: '1000',
  lg: '1100',
  xl: '1200',
  xxl: '1300'
};
export const iconSizes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'small', 'medium', 'large'];
export const getIconSize = size => {
  // return default value when iconSize is invalid or a number
  if (typeof size === 'number' || !(size in iconSizeTokensMap)) {
    return iconSizeTokensMap['xs'];
  }
  return iconSizeTokensMap[size];
};